import { render, staticRenderFns } from "./ContratoAluno.vue?vue&type=template&id=40fe9e87&"
import script from "./ContratoAluno.vue?vue&type=script&lang=js&"
export * from "./ContratoAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports